import {createAction} from 'redux-actions';
import PackagesBundles from "../../Networking/API/PackagesBundles";
import PassesActivate from "../../Networking/API/PassesActivate";

const constants = {};

constants.PACKAGE_BUNDLE_FAILURE = "app/iotg/PACKAGE_BUNDLE_FAILURE";
constants.PACKAGE_BUNDLE_PENDING = "app/iotg/PACKAGE_BUNDLE_PENDING";
constants.PACKAGE_BUNDLE_SUCCESS = "app/iotg/PACKAGE_BUNDLE_SUCCESS";
constants.PACKAGE_ACTIVATE_FAILURE = "app/iotg/PACKAGE_ACTIVATE_FAILURE";
constants.PACKAGE_ACTIVATE_PENDING = "app/iotg/PACKAGE_ACTIVATE_PENDING";
constants.PACKAGE_ACTIVATE_SUCCESS = "app/iotg/PACKAGE_ACTIVATE_SUCCESS";

const packageBundleFailure = createAction(constants.PACKAGE_BUNDLE_FAILURE);
const packageBundlePending = createAction(constants.PACKAGE_BUNDLE_PENDING);
const packageBundleSuccess = createAction(constants.PACKAGE_BUNDLE_SUCCESS);
const packageActivateFailure = createAction(constants.PACKAGE_ACTIVATE_FAILURE);
const packageActivatePending = createAction(constants.PACKAGE_ACTIVATE_PENDING);
const packageActivateSuccess = createAction(constants.PACKAGE_ACTIVATE_SUCCESS);


const getPackageBundles = () => async (dispatch) =>{
    try {
        dispatch(packageBundlePending());
        const response = await PackagesBundles();
        if (response && response.data) {
            dispatch(packageBundleSuccess(response.data))
        }

    } catch (e) {
        dispatch(packageBundleFailure());
        dispatch({
            type: 'alert/OPEN_FAILURE',
            payload: 'generalError'
        })
    }
}

const activatePackage = (uid, token) => async (dispatch) =>{
    try {
        dispatch(packageActivatePending());
        const response = await PassesActivate({uid,token});
        if (response && response.data) {
            dispatch(packageActivateSuccess(response.data))
        }

    } catch (e) {
        dispatch(packageActivateFailure());
        dispatch({
            type: 'alert/OPEN_FAILURE',
            payload: 'generalError'
        })
    }
}

const initialState = {
    loading: false,
    passes: [],
    passesAfterActivation: {},
    errorActivePackage: false
};

export const packagesActions = {
    getPackageBundles,
    activatePackage
};

const PackagesReducer = (state = initialState, {type, payload}) => {
    switch (type) {
        case constants.PACKAGE_BUNDLE_PENDING:
            return {...state, loading: true};
        case constants.PACKAGE_BUNDLE_FAILURE:
            return {...state, loading: false};
        case constants.PACKAGE_BUNDLE_SUCCESS:
            return {...state, loading: false, passes: payload};
        case constants.PACKAGE_ACTIVATE_PENDING:
            return {...state, loading: true};
        case constants.PACKAGE_ACTIVATE_FAILURE:
            return {...state, loading: false};
        case constants.PACKAGE_ACTIVATE_SUCCESS:
            if(payload.result === "GENERAL ERROR") {
                return {...state, loading: false, passesAfterActivation: payload, errorActivePackage: true};
            }else{
                return {...state, loading: false, passesAfterActivation: payload, errorActivePackage: false};
            }
        default:
            return state
    }
}

export default PackagesReducer;